export const GET_DEAL_AMENDMENTS = 'deal_amendment/GET_DEAL_AMENDMENTS'
export const GET_DEAL_AMENDMENT = 'deal_amendment/GET_DEAL_AMENDMENT'
export const ADD_DEAL_AMENDMENTS = 'deal_amendment/ADD_DEAL_AMENDMENTS'
export const EDIT_DEAL_AMENDMENTS = 'deal_amendment/EDIT_DEAL_AMENDMENTS'
export const SUBMIT_DEAL_AMENDMENT = 'deal_amendment/SUBMIT_DEAL_AMENDMENT'
export const REJECT_DEAL_AMENDMENT = 'deal_amendment/REJECT_DEAL_AMENDMENT'
export const APPROVE_DEAL_AMENDMENT = 'deal_amendment/APPROVE_DEAL_AMENDMENT'
export const DELETE_DEAL_AMENDMENT = 'deal_amendment/DELETE_DEAL_AMENDMENT'
export const START_LOADING_DEAL_AMENDMENTS = 'deal_amendment/START_LOADING_DEAL_AMENDMENTS'
export const STOP_LOADING_DEAL_AMENDMENTS = 'deal_amendment/STOP_LOADING_DEAL_AMENDMENTS'
export const DEAL_TERMINATED = 'deal_amendment/DEAL_TERMINATED'